var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBonusesHorArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 25,
    viewBox: "0 0 15 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.31398 24.4898H0.993985C0.637796 24.4876 0.309635 24.2962 0.13247 23.9872C-0.0446962 23.6782 -0.0441189 23.2982 0.133985 22.9898L6.13399 12.7498C6.2233 12.5951 6.2233 12.4045 6.13399 12.2498L0.133985 2.00977C-0.0441189 1.7013 -0.0446962 1.32138 0.13247 1.01237C0.309635 0.703356 0.637796 0.511911 0.993985 0.509768H4.31398C4.90885 0.508802 5.47327 0.772688 5.85398 1.22977L14.724 11.8698C15.0328 12.2405 15.0328 12.779 14.724 13.1498L5.85398 23.7898C5.46945 24.2394 4.90559 24.4957 4.31398 24.4898Z",
    fill: "#25313D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonusesHorArrow);
export default __webpack_public_path__ + "static/media/bonusesHorArrow.95e8bfb14074c937bfc2ec8bafbede72.svg";
export { ForwardRef as ReactComponent };